import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import store from "../../store"
import { SET_AUTH } from "../../store/auth/profile/actionTypes"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { checkBinId, checkCarNumber, checkId, checkWaverBarNumber, deleteBinAccount, deleteCarNumber, deleteDriverAccount, deleteWaverBarNumber, getBinAllList, getBinList, getCarListAll, getMyProfile, getUserByToken, getWaverBarList, passwordChange, passwordReset, patchCompanyData, patchCompanyDetail, saveBinAccount, saveCarNumber, saveDriverAccount, saveWaverBarNumber, updateBinList, updateCarData, updateDriverAccount, updateWaverBarNumber } from "crud/auth.crud"
import { getDriverList } from "crud/search.crud";
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import _ from "lodash";

// 주소 찾기
import DaumPostcode from 'react-daum-postcode';
import { getMyEmitterCompanyList } from "crud/contract.crud";

const initPasswordItem = {
  oldPassword: '',
  newPassword: '',
  passwordConfirm: '',
}

const initWasteBinItem = {
  mount: 60,
}

const WorkplaceManagementCollection = () => {
  const selector = useSelector(state => state)
  const history = useHistory()

  const [driverDataList, setDriverDataList] = useState([]);
  const [selectedDriverItem, setSelectedDriverItem] = useState({})
  const [carDataList, setCarDataList] = useState([]);
  const [selectedCarItem, setSelectedCarItem] = useState({})
  const [wasteBinDataList, setWasteBinDataList] = useState([]);
  const [selectedWasteBinItem, setSelectedWasteBinItem] = useState({})
  const [waverBarDataList, setWaverBarDataList] = useState([]);
  const [selectedWaverBarItem, setSelectedWaverBarItem] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [workplaceItem, setWorkplaceItem] = useState({})
  const [passwordItem, setPasswordItem] = useState(initPasswordItem)
  const [driverItem, setDriverItem] = useState({})
  const [carItem, setCarItem] = useState({})
  const [wasteBinItem, setWasteBinItem] = useState(initWasteBinItem)
  const [waverBarItem, setWaverBarItem] = useState({})
  const [modalShow, setModalShow] = useState({
    post: false,
    workplace: false,
  })
  const [pages, setPages] = useState({
    driver: 1
  })
  const [contractedCompanyDataList, setContractedCompanyDataList] = useState([]);
  const [inputType, setInputType] = useState('')
  const profileData = selector.Profile?.auth?.[0] || selector.auth?.user || {};
  const companyData = profileData?.member_group?.[0]?.company_group || {}
  const companyDetailData = companyData?.company_detail?.[0] || {}

  useEffect(() => {
    setWorkplaceItem({
      id: companyData.id,
      companyName: companyData.name || '',
      businessNumber: companyData.company_number || '',
      representative: companyData.username || '',
      email: companyData.email || '',
      zipcode: companyData.zipCode || '',
      address1: companyData.address1 || '',
      address2: companyData.address2 || '',
      mobilePhone: companyData.mobile_phone || '',
      phone: companyData.phone || '',
      fax: companyData.fax || '',
      collectionSector: companyDetailData?.collection_sector || '',
      employee: companyDetailData?.employee || '',
      sector2: companyDetailData?.sector2 || '',
    })
  }, [])

  const changeWorkplaceInfo = async () => {
    modalClose('workplace')
    if (isLoading)
      return
    setIsLoading(true)
    const companyParams = {
      name: workplaceItem.companyName || '',
      company_number: workplaceItem.businessNumber || '',
      username: workplaceItem.representative || '',
      email: workplaceItem.email || '',
      zipcode: workplaceItem.zipCode || '',
      address1: workplaceItem.address1 || '',
      address2: workplaceItem.address2 || '',
      mobile_phone: workplaceItem.mobilePhone || '',
      phone: workplaceItem.phone || '',
      fax: workplaceItem.fax || '',
    }
    const companyDetailParams = {
      collection_sector: workplaceItem.collectionSector || '',
      employee: workplaceItem.employee || '',
      sector2: workplaceItem.sector2 || '',
    }
    const companyRs = await patchCompanyData(companyData.id, companyParams)
    const companyDetailRs = await patchCompanyDetail(companyDetailData.id, companyDetailParams)
    if (companyRs?.status === 200 && companyDetailRs?.status === 200) {
      setIsLoading(false)
      alert('정상적으로 수정되었습니다.')
      const memberResponse = await getMyProfile(selector.auth?.user?.id);
      store.dispatch({ type: SET_AUTH, data: [memberResponse.data] });
    } else {
      setIsLoading(false)
      alert('수정에 실패하였습니다.')
    }
  }

  const changePassword = async () => {
    if (isLoading)
      return;
    if (passwordItem.newPassword !== passwordItem.passwordConfirm) {
      return alert('새 비밀번호와 비밀번호 확인이 같지 않습니다.')
    }
    setIsLoading(true)
    const params = {
      id: profileData['id'],
      old_password: passwordItem.oldPassword,
      password: passwordItem.newPassword,
    }
    const rs = await passwordChange(params)
    if (rs.data?.result === 'success') {
      setPasswordItem(initPasswordItem)
      modalClose('changePassword')
      setIsLoading(false)
      alert("비밀번호가 정상적으로 변경되었습니다.")
    } else {
      setIsLoading(false)
      alert(rs?.data?.msg || "비밀번호를 정확히 입력해주세요.")
    }
  }

  const changeInputCondition = (path, value, setter) => {
    setter(prev => {
      const keys = path.split(".");
      const newState = { ...prev };
      let curr = newState;

      for (let i = 0; i < keys.length - 1; i++) {
        const k = keys[i];
        curr[k] = { ...curr[k] };
        curr = curr[k];
      }

      curr[keys[keys.length - 1]] = value;
      return newState;
    });
  };

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const checkUserId = async (id, setter) => {
    if (!id || id.length === 0) {
      return alert('아이디를 입력해주세요.')
    }
    var reg = /^[A-Za-z\d]{3,15}$/
    if (!reg.test(id)) {
      return alert('3-15자의 영문/숫자 조합으로 아이디를 입력해주세요.')
    }
    const params = {
      user_id: id,
    }
    const rs = await checkId(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedId', id, setter)
      alert('사용할 수 있는 아이디입니다.')
    } else {
      alert('사용중인 아이디입니다.')
    }
  }

  const resetPassword = async () => {
    if (!selectedDriverItem.id || isLoading)
      return
    if (confirm('비밀번호를 초기화하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        id: selectedDriverItem.id,
      }
      const rs = await passwordReset(params)
      if (rs.data?.result === 'success') {
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
      alert(rs.data.msg)
    }
  }

  const getDriverDataList = async () => {
    setIsLoading(true)

    let params = {
      page: pages.driver,
      company: companyData.id
    }

    const response = await getDriverList(params);
    if (response.data.result === 'success') {
      const content = response.data?.data || [];
      setDriverDataList(content)
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }
  }

  const isPasswordValidated = (item) => {
    let passwordReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordReg.test(item.password) || item.password === '') {
      alert("8자 이상의 영문/숫자 조합으로 비밀번호를 입력해주세요.")
      return false
    }
    if (item.password !== item.passwordConfirmed) {
      alert("비밀번호확인을 정확히 입력해주세요.")
      return false
    }
    return true
  }

  const isValidated = (item) => {
    let emailReg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (item.id === '') {
      alert("아이디를 입력해주세요.")
      return false
    }
    if (!item.confirmedId) {
      alert("아이디 중복확인을 해주세요.")
      return false
    }
    if (item.name === '') {
      alert("이름을 입력해주세요.")
      return false
    }
    if (!emailReg.test(item.email) || item.email === '') {
      alert("유효한 이메일을 입력해주세요.")
      return false
    }
    if (item.mobilePhone === '') {
      alert("휴대폰 번호를 입력해주세요.")
      return false
    }
    return true
  }

  const saveDriver = async () => {
    setIsLoading(true)
    if (!isValidated(driverItem) || !isPasswordValidated(driverItem)) {
      setIsLoading(false)
      return;
    }
    const params = {
      'user_id': driverItem.confirmedId || '',
      'password': driverItem.password || '',
      'username': driverItem.name || '',
      'email': driverItem.email || '',
      'mobile_phone': driverItem.mobilePhone || '',
      'type': 'driver',
      'push_token': '',
      'status': 'Y',
      'company_id': companyData.id
    }
    const rs = await saveDriverAccount(params)
    if (rs.data.result === 'success') {
      modalClose('registerDriver')
      setDriverItem({})
      getDriverDataList()
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const changeDriver = async () => {
    setIsLoading(true)
    if (!isValidated(selectedDriverItem)) {
      setIsLoading(false)
      return;
    }
    const params = {
      'id': selectedDriverItem.id || '',
      'user_id': selectedDriverItem.confirmedId || '',
      'username': selectedDriverItem.name || '',
      'email': selectedDriverItem.email || '',
      'mobile_phone': selectedDriverItem.mobile_phone || '',
    }
    const rs = await updateDriverAccount(params)
    if (rs.data.result === 'success') {
      setIsLoading(false)
      setSelectedDriverItem({})
      getDriverDataList()
    } else {
      setIsLoading(false)
    }
    alert(rs.data?.msg)
  }

  const deleteDriver = async (item) => {
    if (confirm('운전자 계정을 삭제하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        user_id: item.user_id + '_deleted_' + new Date().getTime(),
        email: item.email + '_deleted',
        mobile_phone: item.mobile_phone + '_deleted',
        status: 'N'
      }
      const rs = await deleteDriverAccount(params, item.id)
      if (rs.status === 200) {
        getDriverDataList()
        setIsLoading(false)
        alert('정상적으로 삭제되었습니다.')
      } else {
        setIsLoading(false)
        alert('삭제에 실패하였습니다.')
      }
    }
  }

  const getCarDataList = async () => {
    const response = await getCarListAll(companyData.id)
    if (response.data?.result === 'success') {
      setCarDataList(response.data?.data)
    }
  }

  const checkCarPk = async () => {
    if (!carItem.number) {
      return alert("차량번호를 입력해주세요.")
    }
    setIsLoading(true)
    const params = {
      number: carItem.number,
    }
    const rs = await checkCarNumber(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedNumber', carItem.number, setCarItem)
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const isCarValidated = () => {
    if (carItem.number === '') {
      alert("차량번호를 입력해주세요.")
      return false
    } else if (carItem.confirmedNumber === false) {
      alert("차량번호 중복을 확인해주세요.")
      return false
    } else if (carItem.name === '') {
      alert("차량이름을 입력해주세요.")
      return false
    }
    return true
  }

  const saveCar = async () => {
    setIsLoading(true)
    if (!isCarValidated()) {
      setIsLoading(false)
      return;
    }
    const params = {
      'number': carItem.confirmedNumber,
      'name': carItem.name,
      'company': companyData.id,
      'status': 'Y',
    }
    const rs = await saveCarNumber(params)
    if (rs.status === 201) {
      setCarItem({})
      modalClose('registerCar')
      getCarDataList()
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패했습니다.')
    }
    setIsLoading(false)
  }

  const changeCar = async () => {
    setIsLoading(true)
    const params = {
      'id': selectedCarItem.id || '',
      'number': selectedCarItem.number || '',
      'name': selectedCarItem.name || '',
    }
    const rs = await updateCarData(params)
    if (rs.data.result === 'success') {
      setIsLoading(false)
      setSelectedCarItem({})
      getCarDataList()
      modalClose('vehicle')
    } else {
      setIsLoading(false)
    }
    alert(rs.data?.msg)
  }

  const deleteCar = async (item) => {
    if (confirm('해당 차량정보를 삭제하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        status: 'N'
      }
      const rs = await deleteCarNumber(params, item.id)
      if (rs.status === 200) {
        setIsLoading(false)
        getCarDataList()
        alert('정상적으로 삭제되었습니다.')
      } else {
        setIsLoading(false)
        alert('삭제에 실패하였습니다.')
      }
    }
  }

  const getWasteBinDataList = async () => {
    try {
      const params = {
        company: companyData.id
      }
      const response = await getBinAllList(params);
      const content = response.data?.data || [];
      setWasteBinDataList(content)
    } catch (error) {
      console.error(error);
    }
  }

  const checkWasteBinPk = async () => {
    if (wasteBinItem.id === '') {
      return alert('RFID를 입력해주세요.')
    }
    setIsLoading(true)
    const params = {
      id: wasteBinItem.id,
    }
    const rs = await checkBinId(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedId', wasteBinItem.id, setWasteBinItem)
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const isWasteBinValidated = () => {
    if (wasteBinItem.id === '') {
      alert("RFID를 입력해주세요.")
      return false
    }
    if (!wasteBinItem.confirmedId) {
      alert("RFID 중복확인을 해주세요.")
      return false
    }
    if (wasteBinItem.mount === '') {
      alert("용량을 입력해주세요.")
      return false
    }
    if (_.isEmpty(wasteBinItem.company)) {
      alert("대상업체를 입력해주세요.")
      return false
    }
    return true
  }

  const saveWasteBin = async () => {
    setIsLoading(true)
    if (!isWasteBinValidated()) {
      setIsLoading(false)
      return;
    }
    const params = {
      'id': wasteBinItem.confirmedId,
      'name': wasteBinItem.confirmedId,
      'mount': wasteBinItem.mount,
      'owner': wasteBinItem.company.id,
      'company': companyData.id,
      'status': 'Y',
    }
    const rs = await saveBinAccount(params)
    if (rs.status === 201) {
      modalClose('registerWastebin')
      setWasteBinItem(initWasteBinItem)
      getWasteBinDataList()
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패하였습니다.')
    }
    setIsLoading(false)
  }

  const changeWasteBin = async () => {
    setIsLoading(true)
    const params = {
      mount: selectedWasteBinItem.mount,
      owner: selectedWasteBinItem.new_owner_company_data?.id || selectedWasteBinItem.owner_company_data?.id
    }
    const rs = await updateBinList(params, selectedWasteBinItem.id)
    if (rs.status === 200) {
      setIsLoading(false)
      setSelectedWasteBinItem({})
      modalClose('wastebin')
      getWasteBinDataList()
    } else {
      setIsLoading(false)
      alert('정보 수정에 실패하였습니다.')
    }
  }

  useEffect(() => {
    console.log(selectedWasteBinItem)
  }, [selectedWasteBinItem])

  const deleteWasteBin = async (item) => {
    if (confirm('해당 쓰레기통을 삭제하시겠습니까?')) {
      setIsLoading(true)
      const params = {
        status: 'N'
      }
      const rs = await deleteBinAccount(params, item.id);
      if (rs?.status === 200) {
        setIsLoading(false)
        getWasteBinDataList()
        alert('정상적으로 삭제되었습니다.')
      } else {
        setIsLoading(false)
        alert('삭제에 실패하였습니다.')
      }
    }
  }

  const getWaverBarDataList = async () => {
    setIsLoading(true)

    let params = {
      page: 1,
      company: companyData.id
    }

    const response = await getWaverBarList(params);
    const content = response.data?.results || [];
    setWaverBarDataList([...content])
    setIsLoading(false)
  }

  const checkWaverBarPk = async () => {
    setIsLoading(true)
    if (!waverBarItem.id) {
      setIsLoading(false)
      return alert("웨버바 번호를 입력해주세요.")
    }
    const params = {
      id: waverBarItem.id,
    }
    const rs = await checkWaverBarNumber(params)
    if (rs.data?.result === 'success') {
      changeInputCondition('confirmedId', waverBarItem.id, setWaverBarItem)
    }
    alert(rs.data?.msg)
    setIsLoading(false)
  }

  const isWaverBarValidated = () => {
    setIsLoading(false)
    if (!waverBarItem.id) {
      alert("웨버바 번호를 입력해주세요.")
      return false
    } else if (!waverBarItem.confirmedId) {
      alert("웨버바 번호 중복 확인을 해주세요.")
      return false
    }
    return true
  }

  const saveWaverBar = async () => {
    setIsLoading(true)
    if (!isWaverBarValidated()) {
      setIsLoading(false)
      return;
    }
    const params = {
      'id': waverBarItem.confirmedId,
      'company': companyData.id,
      'car': waverBarItem.car,
      'status': 'Y',
    }
    const rs = await saveWaverBarNumber(params)
    if (rs.status === 201) {
      modalClose('registerWaverBar')
      getWaverBarDataList()
      setWaverBarItem({})
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패했습니다.')
    }
    setIsLoading(false)
  }

  const changeWaverBar = async () => {
    setIsLoading(true)
    const params = {
      id: selectedWaverBarItem?.id,
      car: selectedWaverBarItem?.car_data?.id || ''
    }
    const rs = await updateWaverBarNumber(params, selectedWaverBarItem.oldId)
    modalClose('waverBar')
    if (rs.status === 200) {
      setIsLoading(false)
      setSelectedWaverBarItem({})
      getWaverBarDataList()
      alert('정상적으로 수정되었습니다.')
    } else {
      setIsLoading(false)
      alert('수정에 실패하였습니다.')
    }
  }

  const deleteWaverBar = async (item) => {
    if (confirm("해당 웨버바를 삭제하시겠습니까?")) {
      setIsLoading(true)
      {
        const params = {
          status: 'N'
        }
        const response = await deleteWaverBarNumber(params, item.id);
        if (response?.status === 200) {
          alert('정상적으로 삭제되었습니다.')
        }
      }
      setIsLoading(false)
      getWaverBarDataList()
    }
  }

  // 주소찾기 API
  const Post = () => {

    const complete = (data) => {
      // data.zonecode는 우편번호, data.roadAddress는 도로명주소
      let zipAddress = data.zonecode;
      let roadAddress = data.roadAddress;
      modalClose('post')

      changeInputCondition('zipCode', zipAddress)
      changeInputCondition('companyAddress1', roadAddress)
    }

    return (
      <div>
        <DaumPostcode
          className="postmodal"
          autoClose
          onComplete={complete} />
      </div>
    );
  };

  const getContractedCompanyDataList = async () => {
    const rs = await getMyEmitterCompanyList()
    setContractedCompanyDataList(rs?.data?.data || [])
  }

  useEffect(() => {
    getCarDataList()
    getDriverDataList()
    getWasteBinDataList()
    getWaverBarDataList()
    getContractedCompanyDataList()
  }, [])

  return (
    <React.Fragment>
      <div className="d-flex align-items-center margin-bottom-12">
        <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
        <p className="font-weight-bold font-size-15 mb-0 margin-left-6">사업장 정보</p>
      </div>
      <div className="d-flex w-100 gap-30 align-items-center mb-3">
        <div className="email-rightbar flex-grow-1">
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">상호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={workplaceItem.companyName || ''} onChange={(e) => {
                        changeInputCondition('companyName', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={workplaceItem.companyNumber || ''} onChange={(e) => {
                        changeInputCondition('companyNumber', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">대표자명</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="대표자명을 입력하세요." value={workplaceItem.representative || ''} onChange={(e) => {
                        changeInputCondition('representative', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">이메일주소</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="이메일을 입력하세요." value={workplaceItem.email || ''} onChange={(e) => {
                        changeInputCondition('email', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">사업장 주소</td>
                    <td colSpan="7">
                      <input className='waver-input-box w-8 border-radius-0 margin-right-4' value={workplaceItem.zipCode || ''} disabled placeholder="우편번호" />
                      <button type="button" className="custom-btn secondary-bg w-10 border-radius-0 white-text border-none margin-right-4" onClick={() => {
                        modalOpen('post')
                      }}>
                        주소 찾기
                      </button>
                      <input className='waver-input-box w-30 border-radius-0 margin-right-4' value={workplaceItem.address1 || ''} disabled placeholder="주소" />
                      <input className='waver-input-box w-30 border-radius-0' value={workplaceItem.address2} placeholder="상세 주소" onChange={(e) => {
                        changeInputCondition('address2', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">휴대폰 번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={workplaceItem.mobilePhone || ''} onChange={(e) => {
                        changeInputCondition('mobilePhone', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">전화번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={workplaceItem.phone || ''} onChange={(e) => {
                        changeInputCondition('phone', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">FAX 번호</td>
                    <td className="w-15">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={workplaceItem.fax || ''} onChange={(e) => {
                        changeInputCondition('fax', e.target.value, setWorkplaceItem)
                      }} />
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">업종</td>
                    <td className="w-15">
                      <select className='waver-select-box w-100 border-radius-0' value={workplaceItem.collectionSector || ''} onChange={(e) => {
                        changeInputCondition('collectionSector', e.target.value, setWorkplaceItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        <option value="life">{'생활계'}</option>
                        <option value="worklife">{'사업장 생활계'}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">ID</td>
                    <td className="w-15">{profileData.user_id}</td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">비밀번호</td>
                    <td className="w-15">
                      <button type="button" className="w-100 custom-btn border-radius-0 white-bg primary-text button-border" onClick={() => {
                        modalOpen('changePassword')
                      }}>
                        비밀번호 변경
                      </button>
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">종업원수</td>
                    <td className="w-15">
                      <select className='waver-select-box w-100 border-radius-0' value={workplaceItem.employee || ''} onChange={(e) => {
                        changeInputCondition('employee', e.target.value, setWorkplaceItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        <option value="5under">{'5명 미만'}</option>
                        <option value="5over">{'5명 이상'}</option>
                        <option value="10over">{'10명 이상'}</option>
                        <option value="20over">{'20명 이상'}</option>
                      </select>
                    </td>
                    <td className="w-10 padding-left-8 primary-bg white-text font-size-12">업태</td>
                    <td className="w-15">
                      <select className='waver-select-box w-100 border-radius-0' value={workplaceItem.areaRate || ''} onChange={(e) => {
                        changeInputCondition('areaRate', e.target.value, setWorkplaceItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        <option value="food_waste">{'음식물류 폐기물(액,고상)'}</option>
                        <option value="household_waste">{'사업장 생활폐기물(고상,재활용)'}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-end margin-top-13">
            <button type="button" className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
              modalOpen('workplace')
            }}>사업장 정보 수정</button>
          </div>
        </div>
      </div>

      <Row>
        <Col xs={3}>
          <div className="d-flex align-items-center margin-bottom-12 justify-content-between">
            <div className="d-flex align-items-center">
              <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
              <p className="font-weight-bold font-size-15 mb-0 margin-left-6">운반기사 관리</p>
            </div>
            <div>
              <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => { modalOpen('registerDriver') }}>운반기사 등록</button>
            </div>
          </div>
          <div className="table-responsive" style={{ overflowY: 'scroll', maxHeight: 275 }}>
            <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
              <thead className="chart-thead">
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">이름</th>
                  <th scope="col">휴대폰번호</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>
              <tbody className="chart-tbody">
                {driverDataList.map((item, index) => {
                  return (
                    <tr className="pointer" key={'driver_data_' + index} onClick={() => {
                      setSelectedDriverItem({...item, confirmedId: item.user_id, oldId: item.user_id})
                    }}>
                      <td>{item.user_id}</td>
                      <td>{item.name}</td>
                      <td>{item.mobile_phone}</td>
                      <td>
                        <div className="btn-group waver-common-btn-group">
                          <Button type="button" size="sm" className="waves-effect center-btn btn-common small disactive" onClick={(e) => {
                            e.stopPropagation()
                            deleteDriver(item)
                          }}>삭제</Button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
                {driverDataList.length === 0 &&
                  <tr>
                    <td scope="row" colSpan="14">데이터가 없습니다.</td>
                  </tr>
                }

              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={3}>
          <div className="d-flex align-items-center margin-bottom-12 justify-content-between">
            <div className="d-flex align-items-center">
              <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
              <p className="font-weight-bold font-size-15 mb-0 margin-left-6">차량 관리</p>
            </div>
            <div>
              <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
                modalOpen('registerCar')
              }}>차량 등록</button>
            </div>
          </div>
          <div className="table-responsive" style={{ overflowY: 'scroll', maxHeight: 275 }}>
            <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
              <thead className="chart-thead">
                <tr>
                  <th scope="col">차량번호</th>
                  <th scope="col">차량이름</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>
              <tbody className="chart-tbody">
                {carDataList.map((item, index) => {
                  return (
                    <tr className="pointer" key={'car_data_' + index} onClick={() => {
                      setSelectedCarItem(item)
                    }}>
                      <td>{item.number}</td>
                      <td>{item.name || ''}</td>
                      <td>
                        <div className="btn-group waver-common-btn-group">
                          <Button type="button" size="sm" className="waves-effect center-btn btn-common small disactive" onClick={(e) => {
                            e.stopPropagation()
                            deleteCar(item)
                          }}>삭제</Button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
                {carDataList.length === 0 &&
                  <tr>
                    <td scope="row" colSpan="14">데이터가 없습니다.</td>
                  </tr>
                }

              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={3}>
          <div className="d-flex align-items-center margin-bottom-12 justify-content-between">
            <div className="d-flex align-items-center">
              <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
              <p className="font-weight-bold font-size-15 mb-0 margin-left-6">쓰레기통 관리</p>
            </div>
            <div>
              <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
                modalOpen('registerWastebin')
              }}>쓰레기통 등록</button>
            </div>
          </div>
          <div className="table-responsive" style={{ overflowY: 'scroll', maxHeight: 275 }}>
            <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
              <thead className="chart-thead">
                <tr>
                  <th scope="col">RFID</th>
                  <th scope="col">상호</th>
                  <th scope="col">용량</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>
              <tbody className="chart-tbody">
                {wasteBinDataList.map((item, index) => {
                  return (
                    <tr className="pointer" key={'waste_bin_data_' + index} onClick={() => {
                      setSelectedWasteBinItem(item)
                    }}>
                      <td>{item.id}</td>
                      <td>{item?.owner_company_data?.name}</td>
                      <td>{item?.mount}</td>
                      <td>
                        <div className="btn-group waver-common-btn-group">
                          <Button type="button" size="sm" className="waves-effect center-btn btn-common small disactive" onClick={(e) => {
                            e.stopPropagation()
                            deleteWasteBin(item)
                          }}>삭제</Button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
                {wasteBinDataList.length === 0 &&
                  <tr>
                    <td scope="row" colSpan="14">데이터가 없습니다.</td>
                  </tr>
                }

              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={3}>
          <div className="d-flex align-items-center margin-bottom-12 justify-content-between">
            <div className="d-flex align-items-center">
              <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
              <p className="font-weight-bold font-size-15 mb-0 margin-left-6">웨버바 관리</p>
            </div>
            <div>
              <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
                modalOpen('registerWaverBar')
              }}>웨버바 등록</button>
            </div>
          </div>
          <div className="table-responsive" style={{ overflowY: 'scroll', maxHeight: 275 }}>
            <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
              <thead className="chart-thead">
                <tr>
                  <th scope="col">S/N</th>
                  <th scope="col">연동차량</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>
              <tbody className="chart-tbody">
                {waverBarDataList.map((item, index) => {
                  return (
                    <tr className="pointer" key={'waste_bin_data_' + index} onClick={() => {
                      const selectedItem = { ...item }
                      selectedItem.oldId = item.id
                      setSelectedWaverBarItem(selectedItem)
                    }}>
                      <td>{item.id}</td>
                      <td>{item?.car_data?.number || ''}</td>
                      <td>
                        <div className="btn-group waver-common-btn-group">
                          <Button type="button" size="sm" className="waves-effect center-btn btn-common small disactive" onClick={(e) => {
                            e.stopPropagation()
                            deleteWaverBar(item)
                          }}>삭제</Button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
                {waverBarDataList.length === 0 &&
                  <tr>
                    <td scope="row" colSpan="14">데이터가 없습니다.</td>
                  </tr>
                }

              </tbody>
            </table>
          </div>
        </Col>
      </Row>


      <Row className="margin-top-24">
        <Col xs={3}>
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">ID</td>
                    <td className="w-80">
                      <div className="gap-6 d-flex">
                        <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="ID를 입력하세요." value={selectedDriverItem.user_id || ''} onChange={(e) => {
                          changeInputCondition('user_id', e.target.value, setSelectedDriverItem)
                          changeInputCondition('confirmedId', e.target.value === selectedDriverItem.oldId ? selectedDriverItem.oldId : '', setSelectedDriverItem)
                        }} />
                        <div className="btn-group waver-common-btn-group">
                          <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                            e.stopPropagation()
                            checkUserId(selectedDriverItem.user_id, setSelectedDriverItem)
                          }}>중복확인</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">이름</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="이름을 입력하세요." value={selectedDriverItem.name || ''} onChange={(e) => {
                        changeInputCondition('name', e.target.value, setSelectedDriverItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">휴대폰 번호</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="휴대폰 번호를 입력하세요." value={selectedDriverItem.mobile_phone || ''} onChange={(e) => {
                        changeInputCondition('mobile_phone', e.target.value, setSelectedDriverItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">이메일</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="이메일을 입력하세요." value={selectedDriverItem.email || ''} onChange={(e) => {
                        changeInputCondition('email', e.target.value, setSelectedDriverItem)
                      }} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-between margin-top-16">
            <button className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              resetPassword()
            }}>비밀번호 초기화</button>
            <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
              modalOpen('driver')
            }}>운반기사 정보 수정</button>
          </div>
        </Col>
        <Col xs={3}>
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">차량번호</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="차량번호를 입력하세요." value={selectedCarItem.number || ''} onChange={(e) => {
                        changeInputCondition('number', e.target.value, setSelectedCarItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">차량이름</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="차량이름을 입력하세요." value={selectedCarItem.name || ''} onChange={(e) => {
                        changeInputCondition('name', e.target.value, setSelectedCarItem)
                      }} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-end margin-top-16">
            <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
              modalOpen('vehicle')
            }}>차량 정보 수정</button>
          </div>
        </Col>
        <Col xs={3}>
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">RFID</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="RFID을 입력하세요." value={selectedWasteBinItem.id || ''} disabled />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">상호</td>
                    <td className="w-80">
                      <div className="gap-6 d-flex">
                        <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." disabled value={selectedWasteBinItem?.owner_company_data?.name || ''} />
                        <div className="btn-group waver-common-btn-group">
                          <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                            modalOpen('company')
                            setInputType('edit')
                            e.stopPropagation()
                          }}>업체선택</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">용량</td>
                    <td className="w-80">
                      <div className="gap-6 d-flex">
                        <select className='waver-select-box w-100 border-radius-0' value={selectedWasteBinItem.mount || ''} onChange={(e) => {
                          changeInputCondition('mount', e.target.value, setSelectedWasteBinItem)
                        }}>
                          <option value={60}>60</option>
                          <option value={120}>120</option>
                          <option value={240}>240</option>
                        </select>
                        <div className="btn-group waver-common-btn-group">
                          <p className="mb-0" style={{ lineHeight: '35px' }}>L</p>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-end margin-top-16">
            <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
              modalOpen('wastebin')
            }}>쓰레기통 정보 수정</button>
          </div>
        </Col>
        <Col xs={3}>
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">S/N</td>
                    <td className="w-80">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="S/N을 입력하세요." value={selectedWaverBarItem.id || ''} onChange={(e) => {
                        changeInputCondition('id', e.target.value, setSelectedWaverBarItem)
                      }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="w-20 padding-left-8 primary-bg white-text font-size-12">연동차량</td>
                    <td className="w-80">
                      <select className='waver-select-box w-100 border-radius-0' value={selectedWaverBarItem?.car_data?.id || ''} onChange={(e) => {
                        changeInputCondition('car_data.id', e.target.value, setSelectedWaverBarItem)
                      }}>
                        <option value="" hidden>{'선택해 주세요'}</option>
                        {carDataList.map((item, index) => (
                          <option key={'car_select_update_' + index} value={item.id}>{item.number}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-end margin-top-64">
            <button className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
              modalOpen('waverBar')
            }}>웨버바 정보 수정</button>
          </div>
        </Col>
      </Row>

      <Modal
        title={'우편번호 찾기'}
        show={modalShow.post}
        onHide={() => { modalClose('post') }}
        size="md"
        bodyChildren={
          <Post></Post>
        }
      />

      <Modal
        title={'사업장 정보 수정'}
        show={modalShow.workplace}
        onHide={() => {
          modalClose('workplace')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>사업장 정보를 수정합니다. 수정을 반영할 기존에 설정 되어<br />있는 사업장 전화번호 및 기타 정보가 변경 됩니다.</p>
            <p>정말 사업장 정보를 수정 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              changeWorkplaceInfo()
            }}>
              확인
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('workplace')
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>

      <Modal
        title={'운반기사 정보 수정'}
        show={modalShow.driver}
        onHide={() => {
          modalClose('driver')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>운반기사 정보를 수정합니다.</p>
            <p>정말 운반기사 정보를 수정 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              changeDriver()
            }}>
              확인
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('driver')
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>

      <Modal
        title={'차량 정보 수정'}
        show={modalShow.vehicle}
        onHide={() => {
          modalClose('vehicle')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>차량 정보를 수정합니다.</p>
            <p>정말 차량 정보를 수정 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              changeCar()
            }}>
              확인
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('vehicle')
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>

      <Modal
        title={'쓰레기통 정보 수정'}
        show={modalShow.wastebin}
        onHide={() => {
          modalClose('wastebin')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>쓰레기통 정보를 수정합니다.</p>
            <p>정말 쓰레기통 정보를 수정 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              changeWasteBin()
            }}>
              확인
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('wastebin')
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>

      <Modal
        title={'웨버바 정보 수정'}
        show={modalShow.waverBar}
        onHide={() => {
          modalClose('waverBar')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>웨버바 정보를 수정합니다.</p>
            <p>정말 웨버바 정보를 수정 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              changeWaverBar()
            }}>
              확인
            </button>
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
              modalClose('waverBar')
            }}>
              취소
            </button>
          </div>
        }
      >
      </Modal>

      <Modal title={'운반기사 등록'} show={modalShow.registerDriver} onHide={() => {
        modalClose('registerDriver')
      }} size="md"
        bodyChildren={
          <Fragment>
            <p>운반기사 정보를 등록합니다.</p>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● ID</td>
                  <td className="w-70">
                    <div className="gap-6 d-flex">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="ID를 입력하세요." value={driverItem.id || ''} onChange={(e) => {
                        changeInputCondition('id', e.target.value, setDriverItem)
                      }} />
                      <div className="btn-group waver-common-btn-group">
                        <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                          e.stopPropagation()
                          checkUserId(driverItem.id, setDriverItem)
                        }}>중복확인</button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 비밀번호</td>
                  <td className="w-70">
                    <input className="waver-input-box font-size-12 w-100 border-radius-0" type="password" placeholder="비밀번호를 입력하세요." value={driverItem.password || ''} onChange={(e) => {
                      changeInputCondition('password', e.target.value, setDriverItem)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 비밀번호 확인</td>
                  <td className="w-70">
                    <input className="waver-input-box font-size-12 w-100 border-radius-0" type="password" placeholder="비밀번호 확인을 입력하세요." value={driverItem.passwordConfirmed || ''} onChange={(e) => {
                      changeInputCondition('passwordConfirmed', e.target.value, setDriverItem)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 이름</td>
                  <td className="w-70">
                    <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="이름을 입력하세요." value={driverItem.name || ''} onChange={(e) => {
                      changeInputCondition('name', e.target.value, setDriverItem)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 휴대폰 번호</td>
                  <td className="w-70">
                    <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="휴대폰 번호를 입력하세요." value={driverItem.mobilePhone || ''} onChange={(e) => {
                      changeInputCondition('mobilePhone', e.target.value, setDriverItem)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">이메일</td>
                  <td className="w-70">
                    <input type="email" className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="이메일을 입력하세요." value={driverItem.email || ''} onChange={(e) => {
                      changeInputCondition('email', e.target.value, setDriverItem)
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="font-size-12 mb-0 margin-top-8" style={{ color: '#FF7373' }}>※ “●”  표시는 필수 입력 값 입니다.</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end w-100">
            <button style={{ width: 110, height: 28 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveDriver()
            }}>등록하기</button>
            <button style={{ width: 67, height: 28 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              modalClose('registerDriver')
              setDriverItem({})
            }}>취소</button>
          </div>
        }
      />

      <Modal title={'차량 등록'} show={modalShow.registerCar} onHide={() => {
        modalClose('registerCar')
      }} size="md"
        bodyChildren={
          <Fragment>
            <p>차량 정보를 등록합니다.</p>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 차량번호</td>
                  <td className="w-70">
                    <div className="gap-6 d-flex">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="차량번호를 입력하세요." value={carItem.number || ''} onChange={(e) => {
                        changeInputCondition('number', e.target.value, setCarItem)
                      }} />
                      <div className="btn-group waver-common-btn-group">
                        <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                          e.stopPropagation()
                          checkCarPk()
                        }}>중복확인</button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 차량이름</td>
                  <td className="w-70">
                    <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="차량이름을 입력하세요." value={carItem.name || ''} onChange={(e) => {
                      changeInputCondition('name', e.target.value, setCarItem)
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="font-size-12 mb-0 margin-top-8" style={{ color: '#FF7373' }}>※ “●”  표시는 필수 입력 값 입니다.</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end w-100">
            <button style={{ width: 110, height: 28 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveCar()
            }}>등록하기</button>
            <button style={{ width: 67, height: 28 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              modalClose('registerCar')
            }}>취소</button>
          </div>
        }
      />

      <Modal title={'쓰레기통 등록'} show={modalShow.registerWastebin} onHide={() => {
        modalClose('registerWastebin')
      }} size="md"
        bodyChildren={
          <Fragment>
            <p>차량 정보를 등록합니다.</p>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● RFID</td>
                  <td className="w-70">
                    <div className="gap-6 d-flex">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="RFID를 입력하세요." value={wasteBinItem.id || ''} onChange={(e) => {
                        changeInputCondition('id', e.target.value, setWasteBinItem)
                      }} />
                      <div className="btn-group waver-common-btn-group">
                        <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                          e.stopPropagation()
                          checkWasteBinPk()
                        }}>중복확인</button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">상호</td>
                  <td className="w-70">
                    <div className="gap-6 d-flex">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." disabled value={wasteBinItem.companyName || ''} />
                      <div className="btn-group waver-common-btn-group">
                        <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                          modalOpen('company')
                          setInputType('register')
                          e.stopPropagation()
                        }}>업체선택</button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="w-20 padding-left-8 primary-bg white-text font-size-12">용량</td>
                  <td className="w-80">
                    <div className="gap-6 d-flex">
                      <select className='waver-select-box w-100 border-radius-0' value={wasteBinItem.mount || ''} onChange={(e) => {
                        changeInputCondition('mount', e.target.value, setWasteBinItem)
                      }}>
                        <option value={60}>60</option>
                        <option value={120}>120</option>
                        <option value={240}>240</option>
                      </select>
                      <div className="btn-group waver-common-btn-group">
                        <p className="mb-0" style={{ lineHeight: '35px' }}>L</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="font-size-12 mb-0 margin-top-8" style={{ color: '#FF7373' }}>※ “●”  표시는 필수 입력 값 입니다.</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end w-100">
            <button style={{ width: 110, height: 28 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveWasteBin()
            }}>등록하기</button>
            <button style={{ width: 67, height: 28 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              modalClose('registerWastebin')
            }}>취소</button>
          </div>
        }
      />

      <Modal title={'웨버바 등록'} show={modalShow.registerWaverBar} onHide={() => {
        modalClose('registerWaverBar')
      }} size="md"
        bodyChildren={
          <Fragment>
            <p>웨버바 정보를 등록합니다.</p>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● S/N</td>
                  <td className="w-70">
                    <div className="gap-6 d-flex">
                      <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="S/N를 입력하세요." value={waverBarItem.id || ''} onChange={(e) => {
                        changeInputCondition('id', e.target.value, setWaverBarItem)
                      }} />
                      <div className="btn-group waver-common-btn-group">
                        <button style={{ width: 91 }} type="button" size="sm" className="custom-btn border-radius-0 white-bg primary-text button-border margin-right-0" onClick={(e) => {
                          e.stopPropagation()
                          checkWaverBarPk()
                        }}>중복확인</button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="w-20 padding-left-8 primary-bg white-text font-size-12">연동차량</td>
                  <td className="w-80">
                    <select className='waver-select-box w-100 border-radius-0' value={waverBarItem.car || ''} onChange={(e) => {
                      changeInputCondition('car', e.target.value, setWaverBarItem)
                    }}>
                      <option value="" hidden>{'선택해 주세요'}</option>
                      {carDataList.map((item, index) => (
                        <option key={'car_select_' + index} value={item.id}>{item.number}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="font-size-12 mb-0 margin-top-8" style={{ color: '#FF7373' }}>※ “●”  표시는 필수 입력 값 입니다.</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end w-100">
            <button style={{ width: 110, height: 28 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveWaverBar()
            }}>등록하기</button>
            <button style={{ width: 67, height: 28 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              modalClose('registerWaverBar')
            }}>취소</button>
          </div>
        }
      />

      <Modal title={'비밀번호 변경'} show={modalShow.changePassword} onHide={() => {
        modalClose('changePassword')
      }} size="md"
        bodyChildren={
          <Fragment>
            <p>비밀번호를 변경합니다.</p>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 현재 비밀번호</td>
                  <td className="w-70">
                    <input type="password" className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="현재 비밀번호를 입력하세요." onChange={(e) => {
                      changeInputCondition('oldPassword', e.target.value, setPasswordItem)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 새 비밀번호</td>
                  <td className="w-70">
                    <input type="password" className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="새 비밀번호를 입력하세요." onChange={(e) => {
                      changeInputCondition('newPassword', e.target.value, setPasswordItem)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-30 padding-left-8 primary-bg white-text font-size-12">● 비밀번호 확인</td>
                  <td className="w-70">
                    <input type="password" className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="비밀번호 확인을 입력하세요." onChange={(e) => {
                      changeInputCondition('passwordConfirm', e.target.value, setPasswordItem)
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="font-size-12 mb-0 margin-top-8" style={{ color: '#FF7373' }}>※ “●”  표시는 필수 입력 값 입니다.</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end w-100">
            <button style={{ width: 110, height: 28 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              changePassword()
            }}>변경하기</button>
            <button style={{ width: 67, height: 28 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              modalClose('changePassword')
              setPasswordItem(initPasswordItem)
            }}>취소</button>
          </div>
        }
      />

      <Modal
        title={'업체 선택'}
        show={modalShow.company}
        onHide={() => {
          modalClose('company')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <div className="table-responsive">
              <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                <thead className="chart-thead">
                  <tr>
                    <th scope="col">업체명</th>
                    <th scope="col">사업자번호</th>
                  </tr>
                </thead>
                <tbody className="chart-tbody">
                  {contractedCompanyDataList.map((item, index) => {
                    return (
                      <tr className="pointer" key={'contracted_company_' + index} onClick={() => {
                        modalClose('company')
                        if (inputType === 'edit') {
                          changeInputCondition('owner_company_data.name', item.name, setSelectedWasteBinItem)
                          changeInputCondition('new_owner_company_data', item, setSelectedWasteBinItem)
                        } else {
                          changeInputCondition('companyName', item.name, setWasteBinItem)
                          changeInputCondition('company', item, setWasteBinItem)
                        }
                      }}>
                        <td>{item.name}</td>
                        <td>{item.company_number}</td>
                      </tr>
                    )
                  })}
                  {contractedCompanyDataList.length === 0 &&
                    <tr>
                      <td scope="row" colSpan="14">데이터가 없습니다.</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </Fragment>
        }
        footerChildren={
          <></>
        }
      />
    </React.Fragment>
  )
}

export default WorkplaceManagementCollection
